
import { defineComponent } from "vue";
import DoctorsList from "@/components/Departments/common/DoctorsListTemplate3.vue";
import { DepartmentPropDataInterface } from "@/ts/interfaces";

export default defineComponent({
  data(): DepartmentPropDataInterface {
    return {
      name: "Urology Doctors",
      queryName: "Urology",
      teamName: "Urology team",
    };
  },
  components: { DoctorsList },
});
